<div class="max-w-full overflow-x-auto custom-scrollbar">
  <div id="chartOne" class="min-w-[1000px]">
    <apx-chart
      [series]="series"
      [chart]="chart"
      [colors]="colors"
      [plotOptions]="plotOptions"
      [dataLabels]="dataLabels"
      [stroke]="stroke"
      [xaxis]="xaxis"
      [yaxis]="yaxis"
      [legend]="legend"
      [grid]="grid"
      [fill]="fill"
      [tooltip]="tooltip"
    ></apx-chart>
  </div>
</div>
